import React, { Component, Fragment } from 'react';
import RelationshipMedia from './../../containers/DetailMediaPage/RelationshipMedia';
import { Link } from 'react-router-dom';
import CommentDetailMedia from "../Comment/CommentDetailMedia";
import { BASE_URL } from "../../constants/Common";
import { purchaseMedia } from "../../graphqlDic";
import { compose, graphql } from 'react-apollo';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as TypesMediaPurchase from '../../constants/TypesMediaPurchase';
import { isSlashFirst } from '../../helpers/StringHelper';
import { connect } from 'react-redux';
import { callChange } from './../../helpers/ApiPayment';

class DetailMedia extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: true,
            selectedEpisodes: (this.props.match.params.id_ep ? parseInt(this.props.match.params.id_ep, 10) : 1),
            light: true
        }
    }

    notify = (msg) => toast.info(msg);

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id_ep) {
            this.setState({
                selectedEpisodes: nextProps.match.params.id_ep
            });
        }
    }

    componentWillMount() {
        if (this.props.match.params.id_ep) {
            this.setState({
                selectedEpisodes: this.props.match.params.id_ep
            });
        }
    }

    handleToggleLight = () => {
        this.setState({
            light: !this.state.light
        });
    }

    purchaseMedia = (media) => {
        let { user_info } = this.props;

        if (parseInt(media.type_purchase, 10) === TypesMediaPurchase.NONE) {
            this.notify("Media này chỉ được mua theo gói!");
        } else {
            if (user_info.scoin >= media.scoin) {
                this.props.purchaseMedia({
                    variables: {
                        user_id: parseInt(user_info.id, 10),
                        media_id: parseInt(media.id, 10),
                    }
                }).then((res) => {
                    let data = {};
                    data.email = user_info.email;
                    data.value = -Math.abs(media.scoin); // negative-number
                    data.ordercode = Date.now();
                    let result = callChange(data);
                        result.then(
                            window.location.reload()
                        ).catch(console.log)
                })
                .catch(error => {
                    console.log(error)
                });

            } else {
                this.notify("Tài khoản của bạn không đủ scoin!");
            }
        }
    }

    generateEpisodes(media, selectedEpisodes) {
        let html = [];
        let maxpisodes = media.episodes.length;
        for (let i = 1; i <= maxpisodes; i++) {
            let classVar = null;
            if (i === parseInt(selectedEpisodes, 10)) {
                classVar = 'active';
            }
            html.push(<li className={classVar} key={i} ><Link to={"/media/watch/" + media.id + "/" + i} >{i}</Link></li>)
        }
        return html;
    }

    generateInfo(info = []) {
        let array = [];
        for (let item of info) {
            if (item.name) {
                array.push(item.name);
            }
        }
        return array.join(", ");
    }

    closeModal = () => {
        this.setState({
            modalIsOpen: false
        })
    }

    generatePackages = (packages) => {
        return [...packages].map((item) => {
            return ` <a href='/package-detail/${item.id}' target="_blank"><strong>${item.title}</strong></a>`;
        });
    }

    setContent = (media) => {
        let packages = media.packages;
        let content = '';

        let { user_info } = this.props;
        if (JSON.stringify(user_info) === '{}') {
            return `Bạn phải <a href='/login'><strong>Đăng nhập</strong></a> để xem media này`;
        }
        if (!media.url && media.episodes.length === 0) {
            return 'Hiện tại không thể xem media này';
        }
        switch (media.type_purchase) {
            case TypesMediaPurchase.NONE:
                if (packages && packages.length > 0) {
                    content += `Thông báo: Bạn chỉ có thể xem ${media.name} thông qua gói${this.generatePackages(packages)}?`;
                } else {
                    content += `Thông báo: Bạn không có quyền xem ${media.name}`;
                }
                break;
            case TypesMediaPurchase.DAY:
                content += `Thông báo: Bạn chỉ có thể xem ${media.name} khi ngày xem còn hiệu lực`;
                if (packages && packages.length > 0) {
                    content += ` hoặc thông qua gói${this.generatePackages(packages)}`;
                }
                break;
            case TypesMediaPurchase.SCOIN_AND_DAY:
                content += `Thông báo: Bạn phải mua ${media.name} với giá ${media.scoin} scoin đồng thời phải còn ngày xem phải còn hiệu lực`;
                if (packages && packages.length > 0) {
                    content += ` hoặc thông qua gói${this.generatePackages(packages)}`;
                }
                break;
            case TypesMediaPurchase.SCOIN_OR_DAY:
                content += `Thông báo: Bạn phải mua ${media.name} với giá ${media.scoin} scoin hoặc phải còn ngày xem phải còn hiệu lực`;
                if (packages && packages.length > 0) {
                    content += ` hoặc thông qua gói${this.generatePackages(packages)}`;
                }
                break;
            case TypesMediaPurchase.SCOIN:
                content += `Thông báo: Bạn có muốn mua ${media.name} với giá ${media.scoin} scoin`;
                if (packages && packages.length > 0) {
                    content += ` hoặc thông qua gói${this.generatePackages(packages)}`;
                }
                break;
            default:
                content += `Thông báo: Bạn có muốn mua ${media.name} với giá ${media.scoin} scoin?`;
                break;
        }
        return content;
    }

    isAbleToPurchase = (media) => {
        let isAbleToPurchase = false;
        let { user_info } = this.props;
        if (!media.url || JSON.stringify(user_info) === '{}') {
            return false;
        }

        switch (media.type_purchase) {
            case TypesMediaPurchase.SCOIN_AND_DAY:
                isAbleToPurchase = true;
                break;
            case TypesMediaPurchase.SCOIN_OR_DAY:
                isAbleToPurchase = true;
                break;
            case TypesMediaPurchase.SCOIN:
                isAbleToPurchase = true;
                break;
            default:
                break
        }
        return isAbleToPurchase;
    }

    modal = (modalIsOpen, media) => {
        let content = this.setContent(media);
        return (
            modalIsOpen ? <div className="ReactModal__Content ReactModal__Content--after-open"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    border: '1px solid rgb(204, 204, 204)',
                    background: 'rgba(0, 0, 0, 0.5)',
                    overflow: 'auto',
                    borderRadius: 10,
                    outline: 'none',
                    padding: 20,
                    marginRight: '-50%',
                    zIndex: 9999,
                    width: '500px',
                    transform: 'translate(-50%, -50%)'
                }}>
                <div className="tn-popup-content" dangerouslySetInnerHTML={{ __html: content }} />
                {this.isAbleToPurchase(media) ? <div className="text-center tn-popup-bot">
                    <button type="button" className="btn btn-link tn-confirm-yes tn-popup-in-close" onClick={() => this.purchaseMedia(media)}>Mua</button>
                    <button type="button" className="btn btn-link tn-confirm-no tn-popup-in-close" onClick={this.closeModal}>Hủy</button>
                </div> : null}
            </div> : null
        )
    }

    render() {
        let urlEpisodes = null;
        let media = this.props.getMediaVietId.getMediaVietId;

        if (this.props.getMediaVietId.loading) return "Loading...";
        if (this.props.getMediaVietId.error) return `Error! ${this.props.getMediaVietId.error.message}`;

        let { modalIsOpen } = this.state;

        if (!media) return 'Không tìm thấy media...'; // todo redirect to media not found

        if (media.url) {
            urlEpisodes = media.url;
        } else {
            if (!media.episodes || media.episodes === null || media.episodes.length === 0) {

            } else {
                urlEpisodes = media.episodes[this.state.selectedEpisodes - 1].url;
            }
        }

        let imgThumbnail = null;
        if (media.img) {
            if (media.img.includes('https://') || media.img.includes('http://')) {
                imgThumbnail = media.img;
            } else {
                imgThumbnail = isSlashFirst(media.img) ? media.img : '/' + media.img;
            }
        }

        return (
            <div>
                <div className="detail-video">
                    <div className="top">
                        <div className="container">
                            <div className="clearfix">
                                <div>
                                    <div className={this.state.light ? "detail-video-left video-here media-light-on" : "detail-video-left video-here media-light-off"}>
                                        <ToastContainer />
                                        {!media.is_allow || !urlEpisodes ? <img src={imgThumbnail} className="img-responsive image-thumnail" alt={media.name} />
                                            : <iframe title={media.name} width="100%" height="500" src={urlEpisodes} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />}
                                        {!media.is_allow || !urlEpisodes ?
                                            this.modal(modalIsOpen, media) : null
                                        }
                                        <div className="detail-video-action clearfix">
                                            <div className="pull-left">
                                                <span className="action-btn" role="button" onClick={this.handleToggleLight}>
                                                    <img src="/images/btn-light.png" alt="light off" />
                                                    {this.state.light ? 'Tắt đèn' : 'Bật đèn'}
                                                </span>
                                                <span className="action-btn" role="button" >
                                                    <img src="/images/btn-eye.png" alt="purchase ads" />
                                                    Tắt quảng cáo
                                            </span>
                                            </div>
                                            <div className="pull-right">
                                                <img src="/images/btn-like-facebook.png" alt={"btn like facebook"} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.state.light ? '' : 'overlay'}></div>
                                    <div className="detail-video-right video-detail">
                                        <div className="name">{media.name}</div>
                                        <div className="sub-name">{media.name}</div>
                                        <p>IMDb: {media.scoreImdb && <span className="point">{media.scoreImdb}</span>}</p>
                                        <p>Thể loại: {this.generateInfo(media.kinds)}</p>
                                        <p>Quốc gia: {this.generateInfo(media.nations)}</p>
                                        <p>Ngôn ngữ: {this.generateInfo(media.languages)}</p>
                                        <div>Nội dung chính: <div className="text-gray">{<div dangerouslySetInnerHTML={{ __html: media.content }} />}</div></div>
                                        {
                                            !media.url ? <Fragment><p>Số tập: {this.state.selectedEpisodes} / {media.episodes.length === 0 ? 1 : media.episodes.length}</p>
                                                <ul className="list-inline list-video">
                                                    {this.generateEpisodes(media, this.state.selectedEpisodes)}
                                                </ul></Fragment> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main">
                        <div className="container">
                            <div className="detail-video-left comment">
                                <CommentDetailMedia currentUrl={BASE_URL.slice(0, -1) + this.props.location.pathname} />
                            </div>
                            <div className="detail-video-right related">
                                <RelationshipMedia id={media.id} type={media.type} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user_info: state.root.users
    }
}

export default compose(
    graphql(
        purchaseMedia, {
            name: 'purchaseMedia'
        })
)(connect(mapStateToProps, null)(DetailMedia));



// WEBPACK FOOTER //
// ./src/components/DetailMediaPage/DetailMedia.js